import { loc } from "@/_services/localization"
import { domAttributes, handleAccessibleOnKeyDown, labelFromName, scrollToModelField } from "@/_services/utils"
import React from "react"

function getTableFieldPaths() {
  const elements = document.querySelectorAll(`table [${domAttributes.modelFieldPath}]`)
  return new Set(Array.from(elements, el => el.getAttribute(domAttributes.modelFieldPath)))
}

function getTableRowIndex(modelFieldPath, tableFieldPaths) {
  if (!modelFieldPath || !tableFieldPaths.has(modelFieldPath)) return null
  const match = modelFieldPath.match(/\[(\d+)\]/)
  return match ? parseInt(match[1]) + 1 : null
}

class FormBulletSummary extends React.Component {
  render() {
    const { messages, type, nbOfColumns, position } = this.props

    if (!messages.length) return null

    const tableFieldPaths = getTableFieldPaths()
    const isWarning = type === "warning"
    const isReason = type === "reason"

    return (
      <div
        className="form-bullet-summary"
        role={isWarning || isReason ? "status" : "alert"}
        aria-live={isWarning || isReason ? "polite" : "assertive"}
      >
        <div className={"form-bullet-summary-wrapper" + (position === "bottom" ? " mt-5px" : " mb-5px")} data-summary-type={type}>
          <div className="form-bullet-summary-title min-h-24px flex align-items-center">
            {loc(isWarning ? "Warnings" : isReason ? "Reasons" : "Errors")}:
          </div>

          <ul className="list-none" style={{ ["--form-bullet-summary-columns-nb"]: nbOfColumns }}>
            {messages.map((message, index) => {
              const _message = isReason ? message.label || labelFromName(message.value) : message.value || message
              const isArray = Array.isArray(_message)
              const isString = typeof _message === "string"
              const isMultiLine = isString && _message.includes("\n")
              const hasModelFieldPath = !!message.modelFieldPath
              const rowIndex = getTableRowIndex(message.modelFieldPath, tableFieldPaths)
              const rowPrefix = rowIndex ? `(${rowIndex}) ` : ""
              const _scrollToModelField = () => hasModelFieldPath && scrollToModelField(message.modelFieldPath)

              return (
                <li
                  className="min-h-24px flex align-items-center"
                  data-has-model-field-path={hasModelFieldPath}
                  key={index}
                  {...{ [domAttributes.modelFieldPathRef]: message.modelFieldPath }}
                  onClick={_scrollToModelField}
                  tabIndex={hasModelFieldPath ? "0" : ""}
                  onKeyDown={event => handleAccessibleOnKeyDown({ event, fn: _scrollToModelField })}
                >
                  {isString && !isMultiLine && (
                    <span>
                      {rowPrefix}
                      {loc(_message)}
                    </span>
                  )}
                  {isMultiLine &&
                    _message
                      .split("\n")
                      .filter(message => message?.trim())
                      .map((message, key) => (
                        <>
                          <span>
                            {key === 0 ? rowPrefix : ""}
                            {message?.trim()}
                          </span>
                          <br />
                        </>
                      ))}
                  {isArray && (
                    <span>
                      {rowPrefix}
                      {loc(..._message)}
                    </span>
                  )}
                  {!isString && !isMultiLine && !isArray && typeof _message === "object" && (
                    <span>
                      {rowPrefix}
                      {JSON.stringify(_message)}
                    </span>
                  )}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

export default FormBulletSummary
